import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Table from '../../ui/components/Table';
import {fetchStructureVersions} from './../actions';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';
import {diaBase} from '../../../constants/public-routes';
import dateHelper from '../../../helpers/dateHelper';

class StructureLanguages extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.props.fetchStructureVersions(this.props.params.structureId, 'language');
  }

  render() {
    let {lang, structureVersions} = this.props;
    let head = [<FormattedMessage key="language" id="language"/>, <FormattedMessage key="label" id="structure"/>];
    let items = [];
    if (!structureVersions.item || structureVersions.item.length === 0) {
      items.push([<em key="noVersions"><FormattedMessage id="noVersions"/></em>, null, null]);
    }
    else {
      items = structureVersions.item.map((result, i) => {
        return [<FormattedMessage key={result.attributes.language} id={result.attributes.language}/>,
          <Link key={result.id} url={diaBase(lang) + '/structure/' + result.id}>{result.attributes.label || <FormattedMessage id="noStructureLabel"/>}</Link>];
      });
    }

    return (<Table head={head} items={items}/>);
  }
}

StructureLanguages.propTypes = {
  fetchStructureVersions: PropTypes.func.isRequired,
  structure: PropTypes.object.isRequired,
  structureVersions: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  params: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const {structure, structureVersions} = state;
  let {lang} = ownProps.params;
  return {
    structure,
    structureVersions,
    lang
  };
}

function mapDispatchToProps(dispatch) {
  return {fetchStructureVersions: bindActionCreators(fetchStructureVersions, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(StructureLanguages);



/** WEBPACK FOOTER **
 ** ./src/modules/structures/components/StructureLanguages.js
 **/